module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"uk":{"menu":"Відкрити меню"},"en":{"menu":"Open menu"}}')
  delete Component.options._Ctor
}
